"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFormatterToolbar = exports.TextFormatterToolbarHeight = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../../gen-src/Localize");
var TextFormatterIcons_1 = require("../../icons/TextFormatterIcons");
var TabStyles_1 = require("../../styles/TabStyles");
var BrowserDetection_1 = require("../../utils/BrowserDetection");
var FocusIndicator_1 = require("../../utils/FocusIndicator");
var Math_1 = require("../../utils/Math");
var TypedKeys_1 = require("../../utils/TypedKeys");
var ButtonWidgetShim_1 = require("../Button/ButtonWidgetShim");
var Tooltip_1 = require("../Tooltip/Tooltip");
var MarkupHelpers_1 = require("./MarkupHelpers");
exports.TextFormatterToolbarHeight = 0; // 40;
var IndexAttr = 'data-toolbar-button-index';
var ToolbarButtonStyle = TypeStyle.style({
    padding: 4,
    $nest: {
        '&:disabled': { pointerEvents: 'none' },
        '& ~ &': { marginLeft: 8 },
    }
});
var ToolbarPanelStyleName = TypeStyle.style({
    alignItems: 'center',
    background: TabStyles_1.TabStyles.Colors.F2,
    border: "1px solid " + TabStyles_1.TabStyles.Colors.L5,
    borderBottom: 'none',
    boxSizing: 'border-box',
    display: 'flex',
    height: exports.TextFormatterToolbarHeight,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingTop: 8,
    position: 'relative',
});
exports.TextFormatterToolbar = function (props) {
    var activeFormatters = props.activeFormatters, disabled = props.disabled, textAreaId = props.textAreaId, textAreaElement = props.textAreaElement, htmlAttrs = tslib_1.__rest(props, ["activeFormatters", "disabled", "textAreaId", "textAreaElement"]);
    var _a = React.useState(false), focusWithin = _a[0], setFocusWithin = _a[1];
    var focusIndex = React.useRef(0);
    var toolbarRef = React.useRef(null);
    var handleBlur = React.useCallback(function (e) {
        var _a;
        setFocusWithin(false);
        (_a = htmlAttrs.onBlur) === null || _a === void 0 ? void 0 : _a.call(htmlAttrs, e);
    }, [htmlAttrs.onBlur]);
    var handleFocus = React.useCallback(function (e) {
        var _a, _b;
        var activeButton = (_a = toolbarRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("[" + IndexAttr + "=\"" + focusIndex.current + "\"]");
        setFocusWithin(true);
        activeButton === null || activeButton === void 0 ? void 0 : activeButton.focus();
        (_b = htmlAttrs.onFocus) === null || _b === void 0 ? void 0 : _b.call(htmlAttrs, e);
    }, [focusIndex.current, toolbarRef.current, htmlAttrs.onFocus]);
    var handleKeyDown = React.useCallback(function (e) {
        var _a;
        if (e.key === 'ArrowLeft') {
            focusIndex.current = Math_1.wrap(focusIndex.current - 1, 0, Object.keys(MarkupHelpers_1.FormatterMap).length - 1);
        }
        else if (e.key === 'ArrowRight') {
            focusIndex.current = Math_1.wrap(focusIndex.current + 1, 0, Object.keys(MarkupHelpers_1.FormatterMap).length - 1);
        }
        else {
            return;
        }
        handleFocus(e);
        (_a = htmlAttrs.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(htmlAttrs, e);
    }, [focusIndex.current, handleFocus, htmlAttrs.onKeyDown]);
    var handleMouseDown = React.useCallback(function (e) {
        var _a;
        if (e.currentTarget === e.target) {
            e.preventDefault();
        }
        (_a = htmlAttrs.onMouseDown) === null || _a === void 0 ? void 0 : _a.call(htmlAttrs, e);
    }, [htmlAttrs.onMouseDown]);
    return React.createElement(FocusIndicator_1.__UNSTABLE__INTERNAL__FocusIndicator, null,
        React.createElement("div", tslib_1.__assign({}, htmlAttrs, { "aria-controls": textAreaId, className: ToolbarPanelStyleName, onBlur: handleBlur, onFocus: handleFocus, onMouseDown: handleMouseDown, onKeyDown: handleKeyDown, ref: toolbarRef, role: 'toolbar', tabIndex: focusWithin ? -1 : 0 }), TypedKeys_1.typedKeys(MarkupHelpers_1.FormatterMap).map(function (type, index) {
            return React.createElement(ToolbarButton, { buttonIndex: index, disabled: disabled, formatterType: type, isToggled: activeFormatters.indexOf(type) !== -1, key: type, onMouseDown: function () { return focusIndex.current = index; }, textAreaElement: textAreaElement });
        })));
};
exports.TextFormatterToolbar.displayName = 'TextFormatterToolbar';
// We call `preventDefault()` on MouseDown to prevent the selection in the textarea from clearing when interacting with the buttons
var preventDefault = function (e) { return e.preventDefault(); };
var ToolbarButton = function (props) {
    var _a;
    var buttonIndex = props.buttonIndex, disabled = props.disabled, formatterType = props.formatterType, isToggled = props.isToggled, role = props.role, textAreaElement = props.textAreaElement, htmlAttrs = tslib_1.__rest(props, ["buttonIndex", "disabled", "formatterType", "isToggled", "role", "textAreaElement"]);
    var shortcut = MarkupHelpers_1.FormatterMap[formatterType].keyboardShortcut;
    var shortcutKeyLabel = shortcut === null || shortcut === void 0 ? void 0 : shortcut.keyLabel.toUpperCase();
    var ctrlKeyPrefix = "" + (BrowserDetection_1.isMac ? '⌘' : Localize_1.Messages.keyboardModifierCtrl());
    var shiftKeyPrefix = (shortcut === null || shortcut === void 0 ? void 0 : shortcut.shiftKey) ? "" + (BrowserDetection_1.isMac ? '⇧' : Localize_1.Messages.keyboardModifierShift()) : '';
    var getTooltipContent = function () { return React.createElement("span", null,
        TextFormatterIcons_1.TextFormatterNames[formatterType](),
        shortcutKeyLabel && React.createElement(React.Fragment, null,
            React.createElement("br", null),
            BrowserDetection_1.isMac ? shiftKeyPrefix + ctrlKeyPrefix : ctrlKeyPrefix + shiftKeyPrefix,
            shortcutKeyLabel)); };
    var handleClick = React.useCallback(function () {
        if (textAreaElement) {
            MarkupHelpers_1.applyMarkup(formatterType, textAreaElement);
        }
        else {
            throw new Error('Attempting to format a textArea, but none is available');
        }
    }, [formatterType, textAreaElement]);
    return React.createElement(Tooltip_1.Tooltip, { getContent: getTooltipContent, position: Tooltip_1.TooltipPosition.Top },
        React.createElement(ButtonWidgetShim_1.ButtonWidget, tslib_1.__assign({}, htmlAttrs, { "aria-pressed": isToggled, buttonType: ButtonWidgetShim_1.ButtonType.Icon, children: React.createElement(TextFormatterIcons_1.TextFormatterIcon, { type: formatterType }), className: TypeStyle.classes(ToolbarButtonStyle), disabled: disabled }, (_a = {}, _a[IndexAttr] = buttonIndex, _a), { onClick: handleClick, onMouseDown: preventDefault, tabIndex: -1, testId: formatterType })));
};
//# sourceMappingURL=TextFormatterToolbar.js.map